export default __webpack_public_path__ + "static/web-white-8506d47489cd525ed1481d75775d04fd.svg";